import axios, { AxiosError, isAxiosError } from 'axios'
import { configs } from '@/configs'
import {
  getAccessTokenRefreshedIfPossible,
  getMaintainerAdminSelectedTeam,
} from '@/hooks/useAuth/zustand'
import { toast } from '@/hooks/useToast'

const client = axios.create({
  baseURL: `${configs.BACK_URL}/v1`,
  timeout: 1000 * 60 * 5,
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
})

export async function getHeaders(): Promise<
  Record<string, string> | undefined
> {
  const token = await getAccessTokenRefreshedIfPossible()
  const teamId = getMaintainerAdminSelectedTeam()

  if (!token) return undefined

  return {
    Authorization: `Bearer ${token}`,
    ...(teamId ? { teamId: teamId.toString() } : {}),
  }
}

// add interceptors
client.interceptors.request.use(async (config) => {
  const headers = await getHeaders()
  if (!headers) return config

  const entries = Object.entries(headers)
  for (const [key, value] of entries) {
    config.headers[key] = value
  }
  return config
})

type ErrorResponseData = {
  error?: string
}

const extractErrorMessage = (
  error: AxiosError<ErrorResponseData>,
): string | null => {
  const responseData = error.response?.data
  console.log({ extractErrorMessageErrorData: error, responseData })
  const hasErrorMessage = typeof responseData?.error === 'string'
  if (hasErrorMessage) {
    return responseData.error ?? null
  }
  return 'Erro ao realizar a requisição'
}

client.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ErrorResponseData>) => {
    const isAxiosErrorInstance = isAxiosError(error)
    console.log({ extractErrorMessageError: error, isAxiosErrorInstance })
    if (!isAxiosErrorInstance) {
      return Promise.reject(error)
    }

    const errorMessage = extractErrorMessage(error)
    console.log({
      extractErrorMessageError: error,
      isAxiosErrorInstance,
      errorMessage,
    })

    if (errorMessage) {
      toast({ title: errorMessage, variant: 'destructive' })
    }

    return Promise.reject(error)
  },
)

export async function downloadDocument(
  documentId: string,
  extraHeaders?: Record<string, string>,
) {
  const response = await client.get<Blob>(`/document/download/${documentId}`, {
    responseType: 'blob',
    headers: extraHeaders,
  })
  return response
}

export async function downloadVisualRepresentation(
  id: string,
  extraHeaders?: Record<string, string>,
) {
  const response = await client.get<Blob>(
    `/degree/download/visual-representation/${id}`,
    {
      responseType: 'blob',
      headers: extraHeaders,
    },
  )
  return response
}

export async function downloadBulkDocuments(
  ids: string[],
  isCertificate?: boolean,
) {
  const endpoint = isCertificate ? 'bulk-certificates' : 'bulk'
  const response = await client.get<Blob>(
    `/document/download/${endpoint}/${ids.join(';')}`,
    {
      responseType: 'blob',
    },
  )
  return response
}

export default client
